import reservations from './reservations';
import session from './session';

/**
 * @namespace "services.cda"
 */
export default {
  /**
   * @namespace "services.cda.reservations"
   */
  reservations,
  /**
   * @namespace "services.cda.session"
   */
  session
};
